export default __webpack_public_path__ + "static/media/bootstrap_zeus.4f2a73cb.png";